// src/utils/askAi/askAiTypes.js

export const ASK_AI_TYPES = {
  QUICK_SUMMARY: "quick_summary",
  FULL_ANALYSIS: "full_analysis",
  BACKTEST_REVIEW: "backtest_review",
  BROKER_SUMMARY: "broker_summary",
  HISTORICAL_PATTERN: "historical_pattern",
};
